import axios from 'axios';
import Vue from 'vue';
import NProgress from 'nprogress';
import Cookie from 'js-cookie';
import { loginOut } from '@/config/login';
import md5 from 'js-md5';
Vue.prototype.$md5 = md5;
import store from '@/store';
// import { exitApiFun } from '@/api/login'; //logoutApiFun,
// 错误统一处理
function handelError (res) {
  console.log(res)
  let errDialogText = '';
  //需要登出错误码
  if (res.code == '601' || res.code == '702') {
    Vue.prototype.$myConfirm
      .showMsgBox({
        content: res.msg,
        cancelTopisConfirm: true,
        isShowCancelBtn: false
      })
      .then(() => {
        localStorage.removeItem('token')
    window.location.href = window.location.href.split('#')[0] + '#' + '/login'
    // window.location.href.split('#')[0] + '#' + '/login'
    })
    .catch(error => {
      console.log(error);
    });
    return;
  }
  if (res.code == '711') {
    console.log(res)
    return;
  }
  switch (res.code) {
    case 600:
      errDialogText = res.msg || '未知错误';
      break;
    case '701':
      errDialogText = res.msg || '未知错误';
      break;
    case '999':
      errDialogText = res.msg || '认证错误（token无效或者token过期）';
      break;
    // case '703':
    //   errDialogText = res.msg || '未授予访问权限错误';
    //   break;
    case '704':
      errDialogText = res.msg || '数据库相关错误';
      break;
    case '706':
      errDialogText = res.msg || '服务端通用错误';
      break;
    case '707':
      errDialogText = res.msg || '客户端通用错误';
      break;
    case '708':
      errDialogText = res.msg || '参数校验错误';
      break;
    case '709':
      errDialogText = res.msg || '第三方调用错误';
      break;
    default:
      errDialogText = res.msg;
      Vue.prototype.$msg.error({
        message: res.msg ? res.msg : '接口异常',
        duration: 3000
      });
  }
  Vue.prototype.$msg.error({
    message: errDialogText,
    duration: 3000
  });
}
axios.defaults.withCredentials = false;
const request = axios.create({
  timeout: 35000, // 请求超时时间
  headers: {
    'Content-Type': 'application/json;charset=UTF-8',
    // 'token': '06C6AA2D3CB9C4D4E9BA27D3C2C43CB31216F1FEE0B45CA38D7CAEF6F62B8B7264D440B03690BF3991560BD57E922F31BD8F38D523D30A0D6710980835A573C7'
    'token': localStorage.getItem('token') || '',
    // appKey:"S-1002"
    // roleBid: '1427556563348557826'
  }
});
// request拦截器

request.interceptors.request.use(
  config => {
    // localStorage.setItem('token','06C6AA2D3CB9C4D4E9BA27D3C2C43CB31216F1FEE0B45CA38D7CAEF6F62B8B7264D440B03690BF3991560BD57E922F31BD8F38D523D30A0D6710980835A573C7')
    // debugger
   
    config.headers.token = localStorage.getItem('token') || '';
     console.log(config);
    NProgress.start();

    // 将当前url传给后台
    // config.headers.funcUrl = window.location.pathname;
    // config.baseURL = Vue.prototype.$conf.baseUrl;
    // //开始
    // let paramsObj = {};

    // if (config.url.indexOf('?') != -1) {
    //   let arr = config.url.split('?')[1].split('&');

    //   for (let i of arr) {
    //     paramsObj[i.split('=')[0]] = i.split('=')[1];
    //   }
    //   // console.log(paramsObj);
    // }
    // if (config.data) {
    //   try {
    //     // console.log('=====================', config.data);
    //     let sign = '';

    //     paramsObj.AppKey = config.headers.AppKey;
    //     paramsObj.token = config.headers.token;
    //     Object.keys(paramsObj)
    //       .sort()
    //       .map(key => {
    //         // console.log(JSON.stringify(obj[key]).toString());
    //         sign += paramsObj[key] ? JSON.stringify(paramsObj[key]) : '';
    //         // newData[key] = [key];
    //       }); //排序
    //     // console.log(sign);
    //     // console.log(
    //     //   sign.replace(/"/g, '') + 'gegDSFSG42f' + JSON.stringify(config.data)
    //     // );
    //     let signStr = md5(
    //       sign.replace(/"/g, '') + 'gegDSFSG42f' + JSON.stringify(config.data)
    //     );

    //     config.headers.sign = signStr.toUpperCase();
    //   } catch (error) {
    //     console.log(error);
    //   }
    // } else {
    //   // if (config.method == 'get') {
    //   //   console.log(config.url);
    //   //   let arr = config.url.split('?')[1].split('&'); //先通过？分解得到？后面的所需字符串，再将其通过&分解开存放在数组里
    //   //   let obj = {};
    //   //   for (let i of arr) {
    //   //     obj[i.split('=')[0]] = i.split('=')[1]; //对数组每项用=分解开，=前为对象属性名，=后为属性值
    //   //   }
    //   //   console.log(obj);
    //   // }
    //   try {
    //     let sign = '';

    //     paramsObj.AppKey = config.headers.AppKey;
    //     paramsObj.token = config.headers.token;
    //     Object.keys(paramsObj)
    //       .sort()
    //       .map(key => {
    //         // console.log(key);
    //         if (key == 'AppKey' || key == 'token') {
    //           sign += paramsObj[key] ? JSON.stringify(paramsObj[key]) : '';
    //         }
    //       }); //排序
    //     // console.log(sign.replace(/"/g, '') + 'gegDSFSG42f');
    //     config.headers.sign = md5(
    //       sign.replace(/"/g, '') + 'gegDSFSG42f'
    //     ).toUpperCase();
    //   } catch (error) {
    //     console.log(error);
    //   }
    // }
    //结束
    return config;
  },
  error => {
    NProgress.done();
    Promise.reject(error);
  }
);

// response拦截器
request.interceptors.response.use(
  response => {
    // console.log(response);
    NProgress.done();
    // 如果返回的状态码为200，说明接口请求成功，可以正常拿到数据
    // 否则的话抛出错误
    // console.log(response.config.url);
    let str = location.href.replace('#/', '');

    if (response.status === 200) {
      // console.log(response);
      if (
        response.data.code == 200
        // ||
        // str.indexOf('login') != -1 ||
        // response.config.headers.type == 'email'
      ) {
        return Promise.resolve(response.data);
      } else if (response.config.headers.type == 'file') {
        return Promise.resolve(response);
      } else {
        if (
          response.config.url.indexOf('/dcim/riWorkPoint/getByPointBid/') != -1
        ) {
          return Promise.resolve(response.data);
        }
        // 
        handelError(response.data);
        return Promise.resolve('error');
      }
    } else {
      return Promise.reject(response);
    }
  },
  // 状态码非200
  error => {
    NProgress.done();
    const res = error.response;

    let str = location.href.replace('#/', '');
    // let arr = str.split('/');
    // let arr2 = arr[arr.length - 1].split('?');
    // str.indexOf("login") != -1

    if (str.indexOf('login') != -1) {
      if (error.response.status == 500) {
        return Promise.resolve({
          code: '999',
          msg: '服务器错误，请重试'
        });
      }
      return Promise.resolve(error.data);
    }
    Vue.prototype.$msg.error({
      message: '网络错误',
      duration: 3000
    });
    if (res) {
      return {};
    } else {
      return Promise.reject('');
    }
  }
);
export default request;
